import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";

export function getUserCredit(): Promise<AxiosResponse<number>>{
    const query = '/user/credit';
    return Cirus.get(query);
}